<template>
  <form id="frm_action">
    <div class="p-formgrid row">
      <div class="col-lg-6">

        <div class="">
          <label class="txt-right required">Công ty</label>
            <Dropdown :disabled="mode=='edit'" v-model="company" :options="listCompany" optionLabel="name" placeholder="Tên công ty"/>
            <input class="input_tmp_validator" id="company" />
        </div>
        
        <div class="mt-3">
          <label class="txt-right required">Trang trại</label>
            <Dropdown :disabled="mode=='edit'" v-model="farm" :options="listFarm" optionLabel="name" placeholder="Tên trang trại"/>
            <input class="input_tmp_validator" id="farm" />
        </div>
        
        <div class="mt-3">
          <label class="txt-right required">Mã unit (vuông)</label>
          <InputText
            disabled
            v-model="code"
            class="text-box input-text-box"
            placeholder="Nhập"
          />
          <input class="input_tmp_validator" id="code" />
        </div>
        
        <div class="mt-3">
          <label class="txt-right required">Tên unit</label>
          <InputText
            v-model="name"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
          />
          <input class="input_tmp_validator" id="name" />
        </div>

        <div class="mt-3">
          <label class="txt-right required">Kích thước</label>
          <Dropdown v-model="dimensions" :options="listDimensions" optionLabel="label" placeholder="Chọn" />
          <input class="input_tmp_validator" id="dimensions" />
        </div>

        <div class="mt-3">
          <label class="txt-right required">Số block unit có</label>
            <Dropdown v-model="block" :options="listBlock" optionLabel="label" placeholder="Chọn" :disabled="mode == 'edit'"/>
          <input class="input_tmp_validator" id="block" />
        </div>

        <div class="mt-3">
          <label class="txt-right required">Hàng</label>
          <InputNumber
              :disabled="mode == 'edit'"
              v-model="row"
              class="text-box input-text-box"
              mode="decimal" locale="de-DE" :maxFracionDigits="0"
              placeholder="Nhập"
            />
          <input class="input_tmp_validator" id="row" />
        </div>

        <div class="mt-3">
          <label class="txt-right required">Cột</label>
            <InputNumber
              :disabled="mode == 'edit'"
              v-model="column"
              class="text-box input-text-box"
              mode="decimal" locale="de-DE" :maxFracionDigits="0"
              placeholder="Nhập"
            />
          <input class="input_tmp_validator" id="column" />
        </div>

        <div class="mt-3">
          <label class="txt-right">Hộp</label>
            <InputNumber
              v-model="box"
              disabled
              class="text-box input-text-box"
              mode="decimal" locale="de-DE" :maxFracionDigits="0"
              placeholder="Nhập"
            />
          <input class="input_tmp_validator" id="box" />
        </div>

        <div class="mt-3">
          <label class="txt-right required">Thể tích (m3)</label>
            <InputNumber
              v-model="volume"
              class="text-box input-text-box"
              mode="decimal" locale="de-DE" :maxFracionDigits="0"
              placeholder="Nhập"
            />
          <input class="input_tmp_validator" id="volume" />
        </div>

        <div class="mt-3">
          <label class="txt-right required">Phân công</label>
          <MultiSelect v-model="user" :options="userOptions" :filter="true" :showToggleAll="false" optionLabel="fullname" placeholder="Tên nhân sự">
            <template #value="">
              Chọn
            </template>
          </MultiSelect>

          <div class="mt-2" v-show="user.length > 0">
            <label v-for="(item, index) in user" :key="`user-span-${index}`" class="cus-tags">
              <span class="cs-tag">
                {{item.fullname}}
              </span>
              <i v-show="mode=='add'" class="fas fa-times cs-icon" v-on:click="removeSpan(index, 'user')"></i>
            </label>
          </div>
          <input class="input_tmp_validator" id="user" />
        </div>

        <div class="mt-3">
          <label class="txt-right">Thiết bị</label>
          <MultiSelect v-model="equipment" :options="equipmentOptions" :filter="true" :showToggleAll="false" optionLabel="name" placeholder="Chọn">
            <template #value="">
              Chọn
            </template>
          </MultiSelect>
          
          <div class="mt-2" v-show="equipment.length > 0">
            <label v-for="(item, index) in equipment" :key="`equipment-span-${index}`" class="cus-tags">
              <span class="cs-tag">
                {{item.name}}
              </span>
              <i class="fas fa-times cs-icon" v-on:click="removeSpan(index, 'equipment')"></i>
            </label>
          </div>

          <input class="input_tmp_validator" id="equipment" />
        </div>

        <div class="mt-3">
          <label class="txt-right required">Chủng loại</label>
          <MultiSelect v-model="kindtype" :options="kindtypeOptions" :filter="true" :showToggleAll="false" optionLabel="name" placeholder="Chọn">
            <template #value="">
              Chọn
            </template>
          </MultiSelect>

          <div class="mt-2" v-show="kindtype.length > 0">
            <label v-for="(item, index) in kindtype" :key="`kindtype-span-${index}`" class="cus-tags">
              <span class="cs-tag">
                {{item.name}}
              </span>
              <i class="fas fa-times cs-icon" v-on:click="removeSpan(index, 'kindtype')"></i>
            </label>
          </div>

          <input class="input_tmp_validator" id="kindtype" />
        </div>

        <div class="mt-3 d-flex align-items-center p-0">
          <Checkbox id="active" v-model="active" :binary="true" />
          <label for="active" class="m-0 ml-2">Hoạt động</label>
        </div>      
      </div>

      <Toolbar class="fixed-bottom-toolbar col-lg-12">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>
    </div>
  </form>
</template>

<script>
import DataServices from "@/core/DataServices";
// import { HotModuleReplacementPlugin } from "webpack";
// import gql from "graphql-tag";
export default {
  props: {
    mode: String,
    model: Object,
    users: Array,
  },
  data() {
    return {
      name: "",
      code: "",
      equipmentOptions: [],
      equipment: [],
      kindtype: [],
      kindtypeOptions: [],
      row: 0,
      column: 0,
      box: 0,
      block: {},
      listAlphabet: this.$constants.LIST_ALPHABET,
      listBlock: [
        {
          value: 1,
          label: 1
        },
        {
          value: 2,
          label: 2
        },
        {
          value: 3,
          label: 3
        },
        {
          value: 4,
          label: 4
        },
        {
          value: 5,
          label: 5
        },
      ],
      listDimensions: [
        {
          value: "D300",
          label: "D300"
        },
        {
          value: "D400",
          label: "D400"
        },
        {
          value: "Hop",
          label: "Hộp"
        },
        {
          value: "Be",
          label: "Bể"
        }
      ],
      volume: 0,
      active: true,
      dimensions: {},
      company: null,
      listCompany: [],
      farm: null,
      listFarm: [],
      user: [],
      userOptions: [],
      spans: [],
    };
  },

  //Block không được đụng một khi đã add thì không edit được
  //Do nếu mỗi lần edit block thì sẽ phải tạo lại data của Unit
  //Bảng Unit là bảng block còn bảng cs_unit (bảng fake) mới là bảng unit

  async mounted() {
  console.log("mounted", this.model);
  await this.getListEquipment();
  await this.getListCompany();

  if (this.model !== undefined && Object.keys(this.model).length > 0) {
    this.$commonFuction.is_loading(true);

    try {
      // console.log("model", this.model);
      this.company = this.model.company;
      this.getListFarm();
      await this.getListKindType();

      this.code = this.model.code;

      let nameParts = this.model.name.split(/-(?=[^-]*$)/);
      this.name = nameParts[0]?.trim();

      this.block = { value: this.model.block.length, label: this.model.block.length };

      // Map equipment
      this.equipment = this.model.equipment_has_units.map(m => ({ ...m.equipment }));

      // Map kindtype
      this.kindtype = this.model.unit_has_kind_type.map(m => ({ ...m.kindtype }));

      this.volume = this.model.volume;
      this.row = this.model.row;
      this.column = this.model.column;
      this.farm = this.model.farm;
      if (this.model.users.length) {
          this.user = this.model.users.map((user) => ({
            id: user.user.id,
            fullname: user.user.fullname
          }));
        }

      if (this.dimensions){
        this.dimensions = this.listDimensions.find(m => m.value == this.model.dimensions);
      }

      this.getListUser();

      this.active = this.model.active;
      this.updateSpans();
      this.$commonFuction.is_loading(false);
    } catch (err) {
      console.error("Error in mounted:", err);
      this.$commonFuction.is_loading(false);
    }
  }
},

  watch: {
    async "column"() {
      if (!this.$commonFuction.isEmptyObject(this.block) && this.row > 0 && this.column > 0) {
        this.box = this.block.value * this.row * this.column;
      }
    },
    async "row"() {
      if (!this.$commonFuction.isEmptyObject(this.block) && this.row > 0 && this.column > 0) {
        this.box = this.block.value * this.row * this.column;
      }
    },
    async "block"() {
      if (!this.$commonFuction.isEmptyObject(this.block) && this.row > 0 && this.column > 0) {
        this.box = this.block.value * this.row * this.column;
      }
    },
    async "company"() {
      if (this.mode == "add") {
        if (!this.$commonFuction.isEmptyObject(this.company)) {
          await this.getListFarm();
        }
      }
    },
    async "farm"() {
      if (this.mode == "add") {
        // console.log("farm", this.farm);
        if (!this.$commonFuction.isEmptyObject(this.farm)) {
          var total = await this.getTotalCount();
          // console.log("total", total);
          var farmNameArr = this.farm.name.split(" ");
          // console.log("farmNameArr", farmNameArr);
          var farmCodeArr = farmNameArr.map(m => m.charAt(0).toUpperCase());
          // console.log("farmCodeArr", farmCodeArr);
          this.code = `${farmCodeArr.join('')}UNT${total}`;
        }
      }
      await this.getListUser();
      await this.getListKindType();
    },
    "equipment": {
      handler() {
        this.updateSpans();
      },
      deep: true
    },
    "kindtype": {
      handler() {
        this.updateSpans();
      },
      deep: true
    },
    "user": {
      handler() {
        this.updateSpans();
      },
      deep: true
      
    },
  },
  methods: {
    async getTotalCount() {
      if (!this.$commonFuction.isEmptyObject(this.farm)) {
        try {
          const gqLQueryCount = DataServices.countData("cs_unit");
          const where = {
            farm_id: { _eq: this.farm.id }, 
          };

          const countRes = await this.$apollo.mutate({
            mutation: gqLQueryCount,
            variables: { where_key: where },
          });

          const total =
            countRes.data["cs_unit_aggregate"]["aggregate"]["count"] + 1;

          return total >= 10 ? total : `0${total}`;
        } catch (error) {
          console.error("Error in getTotalCount:", error);
          return "01";
        }
      } else {
        console.warn("Farm is not selected");
        return "01";
      }
    },

    updateSpans() {
      this.spans = [
        ...this.equipment.map((item) => ({ name: item.name, type: 'equipment' })),
        ...this.kindtype.map((item) => ({ name: item.name, type: 'kindtype' })),
        ...this.user.map((item) => ({ name: item.fullname, type: 'user' })),
      ];
    },

    removeSpan(index, type) {
      if (type === 'equipment') {
        this.equipment = this.equipment.filter((item, idx) => idx !== index);
      } else if (type === 'kindtype') {
        this.kindtype = this.kindtype.filter((item, idx) => idx !== index);
      } else if (type === 'user') {
        this.user = this.user.filter((item, idx) => idx !== index);
      }
      this.updateSpans();
    },

    async getListEquipment() {
      var gqLQueryList = DataServices.getList("equipment", {"fields": "id, name"});
      var where = {
          active: {_eq: true},
          deleted_at: {_is_null: true}
      }
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
          orderBy: { created_at: "desc" },
        },
      });
      var listData = resData.data["equipment"];
      this.equipmentOptions = listData;
    },

    async getListKindType() {
      if (!this.$commonFuction.isEmptyObject(this.farm)) {
      var gqLQueryList = DataServices.getList("farm_has_kind_type", {"fields": "kind_type_id"});
      var where = {
        farm_id: {_eq: this.farm.id},
      }
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
        where_key: where,
        },
      });
      var kindTypeIds = resData.data["farm_has_kind_type"].map(item => item.kind_type_id);

      var gqLQueryKindTypeList = DataServices.getList("kind_type", {"fields": "id, name"});
      var kindTypeWhere = {
        id: {_in: kindTypeIds},
      }
      var kindTypeResData = await this.$apollo.mutate({
        mutation: gqLQueryKindTypeList,
        variables: {
        where_key: kindTypeWhere,
        orderBy: { name: "asc" },
        },
      });
      var kindTypeListData = kindTypeResData.data["kind_type"];
      this.kindtypeOptions = kindTypeListData;
      }
    },

    async getListCompany() {
      var gqLQueryList = DataServices.getList("company", {"fields": "id, name"});
      var where = {
          active: {_eq: true},
      }
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
          orderBy: { name: "asc" },
        },
      });
      var listData = resData.data["company"];
      this.listCompany = listData;
    },

    async getListFarm() {
      var gqLQueryList = DataServices.getList("farm", {"fields": "id, name"});
      var where = {
          active: {_eq: true},
          company_id: {_eq: this.company.id}
      }
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
          orderBy: { name: "asc" },
        },
      });
      var listData = resData.data["farm"];
      this.listFarm = listData;
    },

    async getListUser() {
      var gqLQueryList = DataServices.getList("users", { "fields": "id, fullname, farm_id" });
      var where = {
        active: { _eq: true }
      };
      if (this.farm.length > 0) {
        where = {
          ...where,
          farm_id: { _in: this.farm.map(farm => farm.value) }
        };
      }
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
          orderBy: { fullname: "asc" }
        }
      });
      var listData = resData.data["users"];
      this.userOptions = listData;
    },

    backToList() {
      this.$emit("back");
    },

    async validateData() {
      this.validationErrors = {};

      let company_add = document.getElementById("company");
      if (
        this.$commonFuction.isEmptyObject(this.company)
      ) {
        company_add.setCustomValidity("Công ty không được để trống!");
      } else {
        company_add.setCustomValidity("");
      }

      let name_add = document.getElementById("name");
      if (
        this.name == undefined ||
        this.name == null ||
        this.name == ""
      ) {
        name_add.setCustomValidity("Tên unit không được để trống!");
      } else if (this.name.length > 255) {
        name_add.setCustomValidity("Tên unit không được quá 255 ký tự!");
      } else {
        name_add.setCustomValidity("");
      }
      
      let farm_add = document.getElementById("farm");
      if (
        this.$commonFuction.isEmptyObject(this.farm)
      ) {
        farm_add.setCustomValidity("Trang trại không được để trống!");
      } else {
        farm_add.setCustomValidity("");
      }

      let dimensions_add = document.getElementById("dimensions");
      if (
        this.$commonFuction.isEmptyObject(this.dimensions)
      ) {
        dimensions_add.setCustomValidity("Kích thước không được để trống!");
      } else {
        dimensions_add.setCustomValidity("");
      }

      let block_add = document.getElementById("block");
      if (
        this.$commonFuction.isEmptyObject(this.block)
      ) {
        block_add.setCustomValidity("Số block không được để trống!");
      } else {
        block_add.setCustomValidity("");
      }

      let row_add = document.getElementById("row");
      if (
        this.row == undefined ||
        this.row == null ||
        this.row == ""
      ) {
        row_add.setCustomValidity("Hàng không được để trống!");
      } else if (this.row <= 0) {
        row_add.setCustomValidity("Hàng phải lớn hơn 0!");
      } else {
        row_add.setCustomValidity("");
      }

      let column_add = document.getElementById("column");
      if (
        this.column == undefined ||
        this.column == null ||
        this.column == ""
      ) {
        column_add.setCustomValidity("Cột không được để trống!");
      } else if (this.column <= 0) {
        column_add.setCustomValidity("Cột phải lớn hơn 0!");
      } else {
        column_add.setCustomValidity("");
      }

      let volume_add = document.getElementById("volume");
      if (
        this.volume == undefined ||
        this.volume == null ||
        this.volume == ""
      ) {
        volume_add.setCustomValidity("Thể tích không được để trống!");
      } else if (this.volume <= 0) {
        volume_add.setCustomValidity("Thể tích phải lớn hơn 0!");
      } else {
        volume_add.setCustomValidity("");
      }

      let user_add = document.getElementById("user");
      if (this.user.length <= 0) {
        user_add.setCustomValidity("Phân công không được để trống!");
      } else {
        user_add.setCustomValidity("");
      }

      let kindtype_add = document.getElementById("kindtype");
      if (
        this.kindtype.length < 1
      ) {
        kindtype_add.setCustomValidity("Chủng loại không được để trống!");
      } else {
        kindtype_add.setCustomValidity("");
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },

    async addMountedChip() {
      for (let i = 0; i < this.kindtype.length; i++) {
        const chipValue = `${this.kindtype[i].name}`;
        this.kindtype.push(chipValue);
      }
    },

    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      if (Object.entries(this.validationErrors).length !== 0) {
        this.$commonFuction.is_loading(false);
      }
      var params = {
        name: this.name,
        code: this.code.toUpperCase(),
        equipment: this.equipment,
        kindtype: this.kindtype,
        column: this.column,
        row: this.row,
        volume: this.volume,
        company: this.company.id,
        company_id: this.company.id,
        farm: this.farm,
        block: this.block?.value,
        box: this.box,
        dimensions: this.dimensions?.value,
        active: this.active,
        user: this.user.map(user => user.id),
      };
      // console.log("saveData", params);
      this.$emit("save", params);
    },
  },
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 480px;
  height: 270px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.p-multiselect-panel .p-checkbox.p-component {
  display: none !important;
}
.cus-tags{
  border-radius: 10px;
  padding: 8px;
  margin-right: 8px;
  background-color:#F2F3F7;
}
.cs-tag {
  padding: 10px 12px 10px 0px;
  font-weight: normal;
}
.cs-icon {
  color : #666666;
  padding-right: 4px;
  cursor: pointer;
}
.cs-icon-right {
  cursor: pointer;
}
</style>
